<template>
    <div>
        <v-page-title title="Модерация счетов" />
        <div class="admin-forex-application">
            <h3>Счета пользователей</h3>
            <div class="table-filter">
                <v-select title="Статус" name="status" :options="statuses" v-model="status" @input="sortList" />
                <!--                <v-input-->
                <!--                    name="search-user"-->
                <!--                    title="Поиск"-->
                <!--                    placeholder="Например: 777-XXXXXX"-->
                <!--                    type="search"-->
                <!--                    @input="sortList"-->
                <!--                    v-model="searchStr"-->
                <!--                />-->
            </div>
            <v-table
                :desktop-headers="['ID', 'ФИО', 'TG username', 'Статус', 'Дата подачи заявки']"
                :mobile-headers="['ID', 'ФИО', 'Статус']"
                :items="tableData"
                @paginate="onload"
            >
                <template #desktop="item">
                    <td>{{ item.id }}</td>
                    <td style="cursor: pointer">
                        <router-link :to="{ name: 'admin-forex-account', params: { id: item.id } }" style="color:#000">
                            <strong>{{ item.owner.fullname }}</strong>
                        </router-link>
                    </td>
                    <td>
                        <a :href="tgLink(item)">{{ item.owner.tg_username }}</a>
                    </td>
                    <td>
                        {{ item.status.label }}
                    </td>
                    <td>{{ item.created_at }}</td>
                </template>

                <template #mobileHeader="item">
                    <v-table-mobile-header>
                        {{ item.id }}
                    </v-table-mobile-header>
                    <v-table-mobile-header>
                        <strong>{{ item.owner.fullname }}</strong>
                    </v-table-mobile-header>
                    <v-table-mobile-header>
                        <div>
                            {{ item.status.label }}
                        </div>
                    </v-table-mobile-header>
                </template>

                <template #mobile="item">
                    <v-table-mobile-item title="ID">
                        {{ item.id }}
                    </v-table-mobile-item>
                    <v-table-mobile-item title="TG username">
                        <a :href="tgLink(item)">{{ item.owner.tg_username }}</a>
                    </v-table-mobile-item>
                    <v-table-mobile-item title="Дата">
                        {{ item.created_at }}
                    </v-table-mobile-item>
                    <v-table-mobile-item title="Действие">
                        <router-link :to="{ name: 'admin-forex-account', params: { id: item.id } }">
                            <v-button custom-style="secondary">
                                Перейти к заявке
                            </v-button>
                        </router-link>
                    </v-table-mobile-item>
                </template>
            </v-table>
        </div>
    </div>
</template>

<script>
import { ajax } from "@/plugins/api";
import VButton from "@/updated/common/components/VButton";
import SettingSwitch from "@/updated/common/components/form/SettingSwitch";
import { api } from "./services";

const statuses = [
    {
        label: "Все",
        value: ""
    },
    {
        label: "В ожидании",
        value: 0
    },
    {
        label: "Одобрена",
        value: 1
    },
    {
        label: "На модерации",
        value: 2
    },
    {
        label: "Отклонена",
        value: 3
    }
];

const types = [
    { label: "Все", value: "" },
    { label: "PlatformFX", value: "0" },
    { label: "IdeaFX", value: "1" }
];

const subTypes = [
    { label: "Все", value: "" },
    { label: "Валюта", value: "0" },
    { label: "Золото", value: "1" },
    { label: "Робот", value: "2" }
];

const typesDict = ["PlatformFX", "IdeaFX"];
const subTypesDict = ["Валюта", "Золото", "Робот"];

const selectOptions = [
    { label: "Не использовать", value: null },
    { label: "Включить", value: true },
    { label: "Выключить", value: false }
];

const selectTypeOptions = [
    { label: "PlatformFX", value: "0" }
    // { label: "IdeaFX", value: "1" }
];

export default {
    name: "AdminForexApplications",
    components: {
        VButton,
        SettingSwitch
    },
    data() {
        return {
            filters: {
                type: "",
                subType: ""
            },
            type: null,
            settings: null,
            selectOptions,
            statuses,
            types,
            selectTypeOptions,
            typesDict,
            subTypesDict,
            subTypes,
            status: "",
            tableData: [],
            searchStr: "",
            currentPage: 1,
            total: null,
            loading: false
        };
    },
    created() {
        this.onload();
    },
    watch: {
        searchStr() {
            this.onload();
        }
    },
    methods: {
        tgLink(item) {
            return item.owner.username ? "https://t.me/" + item.owner.tg_username : "#";
        },
        sendOverride() {
            if (this.type === null) return;
            ajax.patch(`fxbot/moderator/override?type=` + this.type, this.settings)
                .then(({ data }) => {
                    this.notify({ title: "Глобальные настройки изменены" });
                    this.settings = data;
                })
                .finally(() => (this.loading = false));
        },
        getOverrideSettings() {
            if (this.type === null) return;
            ajax.get(`fxbot/moderator/override?type=` + this.type)
                .then(({ data }) => {
                    this.settings = data;
                })
                .finally(() => (this.loading = false));
        },
        onload(page = 1) {
            this.loading = true;
            ajax.get(
                `tg-interface/admin/accounts?filter[sub_type]=${
                    this.filters.type === "1" ? this.filters.subType : ""
                }&filter[type]=${this.filters.type}&filter[status]=${this.status}&filter[name]=${
                    this.searchStr
                }&page=${page}&per_page=10`
            )
                .then(({ data }) => {
                    this.tableData = data;
                })
                .finally(() => (this.loading = false));
        },
        sortList() {
            this.onload(1);
        }
    }
};
</script>

<style lang="scss" scoped>
.form-override {
    max-width: 480px;
}

.admin-forex-application {
    font-family: "Roboto", sans-serif;
    width: 100%;
    margin: 0 auto;
    min-height: 50vh;
    background: #fff;

    .table-filter {
        margin-bottom: 20px;

        .select {
            margin-bottom: 10px;
            width: 100%;
        }

        @media (min-width: 424px) {
            display: flex;
            .select {
                width: 200px;
                margin-right: 15px;
                margin-bottom: 0;
            }
        }
    }

    .empty-row {
        display: flex;
        justify-content: space-between;
    }
}

/*
.table-box {
    min-height: 100%;

    .table-title {
        font-weight: bold;
        font-size: 20px;
        line-height: 28px;
        color: #1d2228;
        margin-bottom: 30px;
    }

    .sym,
    .data {
        text-align: right;
    }

    table.table {
        border: none;

        tr {
            height: 56px;
        }

        th {
            font-size: 12px;
            line-height: 14px;
            color: #58606e;
        }

        th,
        td {
            padding: 0 15px;
        }

        th > div,
        td > div {
            display: flex;
            align-items: center;
        }

        td.act {
            font-size: 14px;
            line-height: 24px;
            align-items: center;
            color: #1d2228;
        }

        td.sym {
            font-weight: bold;
            font-size: 14px;
            line-height: 24px;
            color: #1d2228;
        }

        td.fio {
            font-weight: bold;
            font-size: 14px;
            line-height: 24px;
            color: #1d2228;
            text-align: left;
            cursor: pointer;
        }

        td.data {
            font-size: 14px;
            line-height: 24px;
            color: #1d2228;
        }

        td.status {
            font-size: 14px;
            line-height: 24px;
            color: #1d2228;

            .status__upper {
                margin-right: 5px;
            }
        }

        td.original {
            font-size: 14px;
            line-height: 24px;
            color: #1d2228;

            svg,
            img {
                margin-right: 5px;
            }
        }

        td.download {
            .icon-download {
                cursor: pointer;
                margin: 0 3px;

                svg {
                    fill: #ffc107;
                    color: #ffc107;
                }
            }

            .icon-more {
                cursor: pointer;
                margin: 0 3px;

                svg {
                    fill: #434a54;
                    color: #434a54;
                }
            }
        }

        th.download {
            text-align: center;
        }

        @media (max-width: 900px) {
            min-width: 100%;
            .act,
            .id,
            .sym,
            .table-header {
                display: none;
            }
            .sym {
                padding-left: 0;
                padding-right: 10px;

                .sym-date {
                    display: block;
                    text-align: left;
                    font-weight: 400;
                }

                div:first-child {
                    justify-content: flex-start !important;
                }
            }
            .download {
                padding-left: 10px;
                padding-right: 0;
            }
            .status {
                padding: 0;
            }
        }

        @media (max-width: 800px) {
            .original.acts {
                display: none;
            }
            td {
                padding: 0 5px;
            }
        }
        @media (max-width: 600px) {
            .data {
                display: none;
            }
        }
    }
}*/
</style>
